<template>
  <div class="trees-component">
    <div class="tree-list-header header table-row">
      <div class="plots-row-wrapper">
        <div class="plots-row">
          <template v-if="lpo.inspection_type_id !== '3'">
            <span>Номер площадки</span>
            <button
              v-for="plot in plotList"
              :key="plot.id"
              @click="selectPlot(plot)"
              :class="{ 'selected-plot': selectedPlot.num === plot.num }"
            >
              {{ plot.num }}
            </button>
          </template>
          <div v-if="selectedTreeList" class="toggle-recount-btn-block">
            <button @click="enableAddMode" :disabled="!actLpoIsDraft">
              Добавить
            </button>
            <button
              :disabled="!selectedTreeList.length || !actLpoIsDraft"
              @click="enableEditMode"
            >
              Редактировать
            </button>
            <button
              :disabled="!selectedTreeList.length || !actLpoIsDraft"
              @click="remove"
            >
              Удалить
            </button>
            <!-- <button @click='tggleRecount'>{{ recountIsOpen ? 'Сохранить перечет' : 'Разблокировать перечет для редактирования' }}</button> -->
          </div>
        </div>
      </div>

      <div v-if="recountIsOpen && addMode" class="add-block-container">
        <!-- <AddBlock :selected-plot='selectedPlot' @close='onAddBlockClose' @added-success='onAdded'/> -->
        <TreesAddRow
          :selectedPlot="selectedPlot"
          @added="onAdded"
          @close="disableAddMode"
        />
      </div>

      <div
        v-if="recountIsOpen && editMode && selectedTreeList.length"
        class="add-block-container"
      >
        <EditBlock
          :selected-plot="selectedPlot"
          :selected-tree-list="selectedTreeList"
          @close="onEditBlockClose"
          @edited-success="onEdited"
        />
      </div>
    </div>

    <!-- <div v-if='!treeList[selectedPlot.id].length'>
			<span>Деревья еще не добавлены</span>
		</div> -->
    <div class="table-container" ref="table-container">
      <table class="tree-list-table flex-item">
        <thead>
          <tr>
            <th>№</th>
            <th>
              <div class="th-flex">
                <FilterComponent
                  text="Порода"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="species"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.species }"
                  @click="sortByColumn('species')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </th>
            <th>
              <div class="th-flex">
                <FilterComponent
                  text="Ярус"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="layer"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.layer }"
                  @click="sortByColumn('layer')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </th>
            <th>
              <div class="th-flex">
                <FilterComponent
                  text="Поколение"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="gen"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.gen }"
                  @click="sortByColumn('gen')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </th>
            <th>
              <div class="th-flex" v-if="lpo.inspection_type_id === '2'">
                <FilterComponent
                  text="Площадь сечения, кв.м"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="s_05"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.s_05 }"
                  @click="sortByColumn('s_05')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
              <div class="th-flex" v-else>
                <FilterComponent
                  text="Диаметр, см"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="d"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.d }"
                  @click="sortByColumn('d')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </th>
            <th>
              <div class="th-flex">
                <FilterComponent
                  text="Категория состояния"
                  :tree-list="treeList[selectedPlot.id]"
                  :filter-obj="filterObj"
                  column="state_cat"
                  @apply-filter="applyFilter"
                />
                <button
                  class="field-sort-btn"
                  :class="{ active: sortObj.state_cat_id }"
                  @click="sortByColumn('state_cat_id')"
                >
                  <i class="fa fa-caret-down"></i>
                </button>
              </div>
            </th>
            <th v-if="filteredList.find((item) => item.nonliquid_reason)">
              Причина неликвидности
            </th>
            <th>Повреждения</th>
            <th v-if="recountIsOpen">
              <custom-p-checkbox
                v-model="checkedAll"
                :disabled="!actLpoIsDraft"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="selectedPlot">
            <tr v-for="tree in filteredList" :key="tree.id">
              <td>{{ tree.tree_num }}</td>
              <td>{{ tree.species }}</td>
              <td v-if="tree.layer == 11">единичные деревья</td>
              <td v-else>{{ tree.layer }}</td>
              <td>{{ tree.gen }}</td>

              <td v-if="lpo.inspection_type_id === '2'">{{ tree.s_05 }}</td>
              <td v-else>{{ tree.d }}</td>

              <td>{{ tree.state_cat }}</td>
              <td v-if="filteredList.find((item) => item.nonliquid_reason)">
                {{ tree.nonliquid_reason }}
              </td>
              <td>
                {{
                  tree.damages
                    .map(
                      (damage) =>
                        damage.reason_id +
                        " - " +
                        damage.reason +
                        "(" +
                        damage.symptom_id +
                        " - " +
                        damage.symptom +
                        ")"
                    )
                    .join(", ")
                }}
              </td>
              <td v-if="recountIsOpen">
                <custom-p-checkbox
                  v-model="selectedTreeList"
                  :multiple="true"
                  :multiple-value="tree"
                  :disabled="!actLpoIsDraft"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

//import AddBlock from "./Recount__treesAdd";
import EditBlock from "./Recount__treesEdit";
import FilterComponent from "./Recount__treesFilter";

import TreesAddRow from "./TreesAddBlock.vue";

export default {
  name: "EditRecountTrees",
  components: {
  //AddBlock,
    EditBlock,
    FilterComponent,
    TreesAddRow,
  },

  props: ["preselectedPlot"],

  data() {
    return {
      selectedPlot: null,

      selectedTreeList: [],
      checkedAll: false,

      filterObj: {
        species: [],
        layer: [],
        gen: [],
        d: [],
        state_cat: [],
        s_05: [],
      },

      sortObj: {
        species: false,
        layer: false,
        gen: false,
        d: false,
        state_cat_id: false,
        s_05: false,
      },
      addMode: false,
      editMode: false,
    };
  },
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    filteredList() {
      const l = this.treeList[this.selectedPlot.id] ? this.treeList[this.selectedPlot.id]: [];
      const list = l
        .filter((tree) => {
          for (const column in this.filterObj) {
            if (!this.filterObj[column].length) {
              continue;
            }

            if (!this.filterObj[column].find((item) => item === tree[column])) {
              return false;
            }
          }

          return true;
        })
        .sort((a, b) => {
          for (const sortField in this.sortObj) {
            const isFieldSorted = this.sortObj[sortField];
            if (isFieldSorted) {
              if (!isNaN(+a[sortField])) {
                if (+a[sortField] > +b[sortField]) {
                  return 1;
                } else if (+a[sortField] < +b[sortField]) {
                  return -1;
                }
              } else {
                if (a[sortField] > b[sortField]) {
                  return 1;
                } else if (a[sortField] < b[sortField]) {
                  return -1;
                }
              }
            }
          }
          return 0;
        });

      return list;
    },

    filteredListLength() {
      return this.filteredList.length;
    },

    selectedTreeListLength() {
      return this.selectedTreeList.length;
    },

    ...mapState("selectedLpo/recount", {
      plotList: (state) => state["plotList"],
      treeList: (state) => state["treeList"],
    }),

    ...mapGetters("selectedLpo/recount", ["recountIsOpen"]),
  },
  watch: {
    checkedAll(checked) {
      if (checked) {
        this.selectedTreeList = this.filteredList.slice(0);
      } else {
        this.selectedTreeList = [];
      }
    },
    selectedTreeListLength(length) {
      this.disableEditMode();
    },
  },
  methods: {
    enableAddMode() {
      this.disableEditMode();
      this.addMode = true;
    },
    disableAddMode() {
      this.addMode = false;
    },

    enableEditMode() {
      this.disableAddMode();
      this.editMode = true;
    },

    disableEditMode() {
      this.editMode = false;
    },

    selectPlot(plot) {
      this.selectedPlot = plot;
    },

    onAddBlockClose() {
      this.disableAddMode();
    },
    onEditBlockClose() {
      this.disableEditMode();
    },
    onAdded() {
      console.log("added");
      this.updatePlotList(this.lpo.lpo_id);
      const container = this.$refs["table-container"];
      setTimeout(() => {
        container.scrollTop = container.scrollHeight;
      }, 200);

      // window.scrollTo(0, container.scrollHeight);
    },
    onEdited() {
      this.selectedTreeList = [];
      this.disableEditMode();
    },

    remove() {
      const payload = {
        plot_id: this.selectedPlot.id,
        selectedTrees: this.selectedTreeList,
      };
      this.removeSelectedTrees(payload).then((res) => {
        //this.updateTreeListOfPlot(this.selectedPlot.id);
        this.getTreeList(this.plotList);
        this.updatePlotList(this.lpo.lpo_id);
        this.selectedTreeList = [];
      });
    },

    tggleRecount() {
      this.toggleRecount(this.lpo.lpo_id).then((res) => {
        this.updatePlotList(this.lpo.lpo_id);
      });
    },

    applyFilter(data) {
      this.filterObj[data.column] = data.items;
    },

    sortByColumn(column) {
      this.sortObj[column] = !this.sortObj[column];
      // console.log(JSON.stringify(this.sortObj, null, 2));
    },

    ...mapActions("selectedLpo/recount", [
      "removeTree",
      "removeSelectedTrees",
      "toggleRecount",
      "updatePlotList",
      "getTreeList"
    ]),
  },
  created() {
    if (this.preselectedPlot) {
      this.selectedPlot = this.preselectedPlot;
    } else {
      this.selectedPlot = this.plotList.length ? this.plotList[0] : null;
    }
  },
};
</script>

<style scoped src="@/style/flex.css"></style>
<style scoped src="@/style/table.css"></style>

<style scoped>
.trees-component {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.table-container {
  flex: 1;
  overflow: auto;
  border-bottom: 1px solid #c0c0c0;
}

.tree-list-table {
  font-size: 0.9rem;
  width: 100%;
  border-collapse: separate;
}

.tree-list-table th,
.tree-list-table td {
  border-top: 1px solid #c0c0c0;
  border-left: 1px solid #c0c0c0;
  text-align: center;
  vertical-align: middle;
}
.tree-list-table td {
  padding: 6px 4px;
}
.tree-list-table th:last-child,
.tree-list-table td:last-child {
  border-right: 1px solid #c0c0c0;
}
.tree-list-table tr:last-child td {
  border-bottom: 1px solid #c0c0c0;
}

.tree-list-table th {
  position: sticky;
  top: 0;

  background-color: #343a40;
  color: #fff;
}

.th-flex {
  display: flex;
}
.th-flex > div {
  flex: 1;
}

.field-sort-btn {
  background-color: #343a40;
  outline: none;
  border: none;
  color: #fff;
  cursor: pointer;
  border-left: 1px solid white;
}
.field-sort-btn.active {
  background-color: dodgerblue;
}

.toggle-recount-btn-block {
  float: right;
}
.toggle-recount-btn-block > button {
  margin-left: 8px;
}

.plots-row-wrapper {
  background-color: white;
  padding: 0.1px;
}
.plots-row {
  margin: 10px 0;
}
.plots-row::after {
  content: "";
  clear: both;
  display: table;
}

.selected-plot {
  color: white;
  background-color: black;
}
</style>

<!-- Переопределение bootstrap -->
<style>
.trees-component .tree-list-table th .b-dropdown {
  width: 100%;
  font-size: 0.9rem;
}
.trees-component .tree-list-table th .dropdown-toggle {
  font-size: 0.9rem;
}
</style>
